"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  pullText: '下拉刷新',
  dropText: '释放立即刷新',
  loadingText: '加载中',
  successText: '加载成功',
  failureText: '加载失败',
  completeText: '我是有底线的'
};
exports.default = _default;